
import Vue from "vue";

import HostedRegistrationPayment from "@/components/common/HostedRegistrationPayment.vue";
import Signature from "@/components/common/inputs/Signature.vue";
import SimpleFeeTable from "@/components/common/SimpleFeeTable.vue";
import FooterText from "@/components/common/FooterText.vue";
import AffiliateSignatureText from "@/components/common/AffiliateSignatureText.vue";

import router from "@/router";
import { UserInfo } from "@/types/User";

const thumbsUpImage = require('@/assets/thumbs-up-duotone.svg');

export default Vue.extend({
  name: "AffiliatePayment",
  components: {
    HostedRegistrationPayment,
    Signature,
    SimpleFeeTable,
    FooterText,
    AffiliateSignatureText,
  },
  props: {
    title: String,
    renewal: Boolean,
    changePage: Function,
    status: Object,
    submitRequest: Function,
    fee: Number,
    feeInfo: Object,
  },
  data: function () {
    return {
      thumbsUpImage,
      dialog: false,
      dialogError: false,
      signature: "",
      processingRequest: false,
      isValid: true,
      errorMessage: "",
    };
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    openModal: function () {
      this.$data.dialog = true;
    },
    openErrorModal: function () {
      this.$data.dialogError = true;
    },
  },
  watch: {
    status: function (newVal: any, oldVal: any) {
      if (newVal.success) {
        this.openModal();      
      } else if (!!this.status.data && newVal.data.error) {            // Actual descriptive message received from the API
        this.errorMessage = newVal.data.error;
        this.openErrorModal();
      } else if (newVal.message) {                        // Likely "Request failed with status code 500" or something, but definitely an error
        this.errorMessage = newVal.message;
        this.openErrorModal();
      } else {                                            // Something really weird happened in this case
        this.errorMessage = "An unknown error occurred.";
        this.openErrorModal();
      }
    },
    dialog: function (newVal: boolean, oldVal: boolean) {
      if (!newVal) {
        this.$store.dispatch("loadPersonTasks", this.userInfo.personId);
        router.push({ path: "/" });
      }
    },
    dialogError: function (newVal: boolean, oldVal: boolean) {      
      if (!newVal && this.status.data && this.status.data.paymentIssue) {
        this.processingRequest = false;
        this.$store.dispatch("loadPersonTasks", this.userInfo.personId);
        router.push({ path: "/" });
      } else if (!newVal) {
        this.processingRequest = false;
      }
    },
  },
});
